import React, { useState,useEffect } from "react";
import { Link,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import ClassStudyInformation from "../components/classes/ClassStudyInformation";

import { ChangeSimpleDateString,isObjEmpty,LoginAfterCheckLogin,GetMonthDateString,GetLocalStorageValue } from "../../components/common/Common";
import main01Icon from "../../img/icon/icon-center-main01.svg";
import class01Icon from "../../img/icon/icon-center-class-01.svg";
import class02Icon from "../../img/icon/icon-center-class-02.svg";
import class03Icon from "../../img/icon/icon-center-class-03.svg";
import class04Icon from "../../img/icon/icon-center-class-04.svg";

import "../../css/style.css";

//클래스 상세 - 원생관리등
const ClassInformation = () => {
  let { cl_idx } = useParams();
  LoginAfterCheckLogin(2);  //로그인 상태 점검

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varClassInfo,setClassInfo] = useState({});
  const [varClassStudyList,setClassStudyList] = useState([]);

  //전개하여 참여중인 원생을 보여줄 수업차수번호
  const [varClassStudyIndex,setClassStudyIndex] = useState(0);

  //현재 호출된 수업형식
  const [varClassStudyType,setClassStudyType] = useState(0);

  //클래스정보호출 - 편집모드
  const GetClassInformation = async() => {
    const sendData = {cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_children_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //클래스정보
        setClassInfo(datas.classes[0]);
        //setClassMode(datas.classes[0].cl_mode);

        //클래스 수업 차수 배열
        const studys = datas.classstudys;
        const childrens = datas.classstudychildrens;
        for(var i=0; i < studys.length; i++) {
          const studyData = studys[i];
          let childrenArray = childrens.filter(el=>el.cs_idx===studyData.cs_idx);
          studys[i]['childrens'] = childrenArray;
        }
        //console.log(studys);
        setClassStudyList(studys);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    let studyMode = GetLocalStorageValue('class_information',0);
    setClassStudyType(studyMode);

    let studyIndex = GetLocalStorageValue('class_study_index',0);
    setClassStudyIndex(studyIndex);

    //서버로부터 정보 호출
    GetClassInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //수업차수 내용 보기
  const onShowStudyInfoHandler = (e,cs_idx) => {
    let studyIndex = 0;
    if(varClassStudyIndex !== cs_idx) studyIndex = cs_idx;
    setClassStudyIndex(studyIndex);
    localStorage.setItem('class_study_index',cs_idx);
  }

  return isObjEmpty(varClassInfo)?null:(
    <div className="vh-content class-center-wrap">
      <HeaderBranchTitle varPageTitle={'클래스 상세'} varBackString={localStorage.getItem('backPageUrl')}/>
      <div className="vh-content-body">
        <div className="view-con">
          <div className="center-wrap">
            <div className="class-info-box">
              <div className="top-line">
                <div className="left">
                  <img src={main01Icon} alt=""/>
                  <span>{varClassInfo.cl_type===1?"마마몽떼":"플라이"}<br/>{varClassInfo.cr_name}</span>
                </div>
                <div className="link-wrap">
                  <Link to={`/Branch/StudyChildrenSet/${cl_idx}`}>원생 설정</Link>
                  <Link to={`/Branch/ClassDetail/${cl_idx}`}>클래스 설정</Link>
                </div>
              </div>
              <div className="txt-box">
                <p className="class-tit">{varClassInfo.sm_name}</p>
                <div className="cl-info-line flex">
                  <div><img src={class01Icon} alt=""/><p>{varClassInfo.cl_name}</p></div>
                  <div><img src={class02Icon} alt=""/><p>{varClassInfo.childrens}명</p></div>
                </div>
                <div className="cl-info-line flex">
                  <div><img src={class03Icon} alt=""/><p>{ChangeSimpleDateString(varClassInfo.sm_sdate)} ~ {GetMonthDateString(varClassInfo.sm_edate)}</p></div>
                  <div><img src={class04Icon} alt=""/><p>{varClassInfo.cl_studys}차수업</p></div>
                </div>
              </div>
            </div>
            {varClassStudyList.length===0?null:
              <div className="class-list-wrap" style={{marginTop:"20px"}}>
                <div className="list-con">
                  <ul>
                    {varClassStudyList.map((studys,i)=>(
                      <li key={'study_'+i} className={studys.cs_idx===varClassStudyIndex?"on":""}>
                        <ClassStudyInformation varClassStudyType={varClassStudyType} varClassStudyIndex={varClassStudyIndex} varClassStudyInfo={studys} onShowStudyInfoHandler={onShowStudyInfoHandler}/>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>   
  );

}
export default ClassInformation;